<div *ngIf="loadingFlag" class="black-text">Now Loading</div>
<router-outlet (activate)="onActivate($event)"></router-outlet>
  